import {
  REPORT_DOWNLOAD_RESULT_REQUEST,
  REPORT_DOWNLOAD_RESULT_SUCCESS,
  REPORT_DOWNLOAD_RESULT_FAILURE,
} from '../actions/types/ReportActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';
import { getDownloadFailureMessage } from '../../ReportDownloadMessages';

const reportInitialState = {
  zip: '',
  asyncReportData: {},
  asyncReportMetaData: {},
  request: null,
  status: 'idle',
  failureMessage: null,
};

export default (state = reportInitialState, action) => {
  switch (action.type) {
    case REPORT_DOWNLOAD_RESULT_REQUEST:
      return {
        ...reportInitialState,
        request: action.payload,
        status: 'loading',
        asyncReportMetaData: state.request && action.payload.batchNo > 1
          && state.request.reportName === action.payload.reportName
          && state.request.execId === action.payload.execId ? state.asyncReportMetaData : {},
      };
    case REPORT_DOWNLOAD_RESULT_SUCCESS:
      if (!state.request || !action.meta || action.meta.requestId !== state.request.requestId) {
        return state;
      }
      return {
        ...state,
        status: 'success',
        failureMessage: null,
        zip: action.payload.asyncReportData.content,
        asyncReportData: action.payload.asyncReportData,
        asyncReportMetaData: action.payload.asyncReportMetaData.content,
      };
    case REPORT_DOWNLOAD_RESULT_FAILURE:
      if (!state.request || !action.meta || action.meta.requestId !== state.request.requestId) {
        return state;
      }
      return {
        ...state,
        zip: '',
        status: 'failure',
        failureMessage: getDownloadFailureMessage(action.payload),
      };
    case LOGGED_OUT:
      return reportInitialState;
    default:
      return state;
  }
};
